<h1 cds-text="title">View Constraint</h1>
<app-constraint-ext-summary *ngIf="!notFound" [constraint]="constraint"></app-constraint-ext-summary>
<clr-alerts *ngIf="notFound">
  <clr-alert [clrAlertType]="'danger'" [clrAlertClosable]="false">
    <clr-alert-item>
      <span>Constraint not found</span>
    </clr-alert-item>
  </clr-alert>
</clr-alerts>
